import { render } from "./Aside.vue?vue&type=template&id=29a55538&scoped=true"
import script from "./Aside.vue?vue&type=script&lang=js"
export * from "./Aside.vue?vue&type=script&lang=js"

import "./Aside.vue?vue&type=style&index=0&id=29a55538&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29a55538"],['__file',"src/components/Aside.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "29a55538"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('29a55538', __exports__)) {
    api.reload('29a55538', __exports__)
  }
  
  module.hot.accept("./Aside.vue?vue&type=template&id=29a55538&scoped=true", () => {
    api.rerender('29a55538', render)
  })

}


export default __exports__